import { render, staticRenderFns } from "./customer-tasks.vue?vue&type=template&id=16371f16&"
import script from "./customer-tasks.vue?vue&type=script&lang=js&"
export * from "./customer-tasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports